/**
 *
 * Created Date: 2019-04-03, 11:24:43 (zhenliang.sun)
 * Last Modified: 2019-04-03, 15:43:14 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

import { GraphType } from './../constants/Constants';
import CanvasSingleArrow from './CanvasSingleArrow';
import CanvasArrowBase from './CanvasArrowBase';
/**
 * 双向箭头
 *
 * @export
 * @class CanvasDoubleArrow
 * @extends {CanvasArrowBase}
 * @author zhenliang.sun
 */
export default class CanvasDoubleArrow extends CanvasSingleArrow {
  constructor(app) {
    super(app);
  }

  static toAddData(target) {
    let obj = CanvasArrowBase.toAddData(target);
    obj.gtype = GraphType.DOUBLE_ARROW;
    obj.path = target.path;
    return obj;
  }

  drawArrow(fromX, fromY, toX, toY, theta, headlen) {
    theta = typeof theta !== 'undefined' ? theta : 30;
    headlen = typeof theta !== 'undefined' ? headlen : 10;
    // 计算各角度和对应的P2,P3坐标
    var angle = (Math.atan2(fromY - toY, fromX - toX) * 180) / Math.PI;
    var angle1 = ((angle + theta) * Math.PI) / 180;
    var angle2 = ((angle - theta) * Math.PI) / 180;
    var topX = this._toFixed(headlen * Math.cos(angle1));
    var topY = this._toFixed(headlen * Math.sin(angle1));
    var botX = this._toFixed(headlen * Math.cos(angle2));
    var botY = this._toFixed(headlen * Math.sin(angle2));
    fromX = this._toFixed(fromX);
    fromY = this._toFixed(fromY);
    toX = this._toFixed(toX);
    toY = this._toFixed(toY);

    var arrowX = 0;
    var arrowY = 0;

    let path = '';

    // 原点箭头
    arrowX = this._toFixed(fromX - topX);
    arrowY = this._toFixed(fromY - topY);
    path += ' M ' + arrowX + ' ' + arrowY;
    path += ' L ' + fromX + ' ' + fromY;
    arrowX = this._toFixed(fromX - botX);
    arrowY = this._toFixed(fromY - botY);
    path += ' L ' + arrowX + ' ' + arrowY;
    path += ` M ${fromX} ${fromY}`;
    path += ` L ${toX} ${toY}`;

    // 目标点箭头
    path += ' L ' + toX + ' ' + toY;
    arrowX = this._toFixed(toX + topX);
    arrowY = this._toFixed(toY + topY);
    path += ' M ' + arrowX + ' ' + arrowY;
    path += ' L ' + toX + ' ' + toY;
    arrowX = this._toFixed(toX + botX);
    arrowY = this._toFixed(toY + botY);
    path += ' L ' + arrowX + ' ' + arrowY;
    return path;
  }
}
